// src/firebase.js
import { initializeApp, setLogLevel } from "firebase/app";
import {
  getAuth,
  signInWithRedirect,
  getRedirectResult,
  SAMLAuthProvider,
  OAuthProvider,
} from "firebase/auth";

console.log("[firebase.js] Initializing Firebase...");
console.log("[firebase.js] Initializing Firebase...");
setLogLevel("debug");

const firebaseConfig = {
  apiKey: "AIzaSyDvAyWVhkS7M_3ZjlWif9GLoxLXOq0zZsY",
  authDomain: "sso-enterprise-1c38c.web.app",
  // authDomain: "serene-muffin-e5c4f3.netlify.app",
  // authDomain: "4bb5c160e05f.ngrok-free.app",
  projectId: "sso-enterprise-1c38c",
  storageBucket: "sso-enterprise-1c38c.firebasestorage.app",
  messagingSenderId: "47760493546",
  appId: "1:47760493546:web:7c68d4b6c6ff5b3eee0093",
  measurementId: "G-2GY33PHNZ0",
};

console.log("[firebase.js] Firebase config:", firebaseConfig);

const app = initializeApp(firebaseConfig);
console.log("[firebase.js] Firebase app initialized:", app);

const auth = getAuth(app);
console.log("[firebase.js] Firebase Auth initialized:", auth);

// const providerId = "saml.sso-enterprise-test";
// const samlProvider = new SAMLAuthProvider(providerId);
// console.log(
//   `[firebase.js] SAMLAuthProvider initialized with provider ID: ${providerId}`
// );

// export { auth, samlProvider, signInWithRedirect, getRedirectResult };

// Set up OIDC provider for Azure Entra ID

const providerId = "oidc.kotak-enterprice-sso"; // The OIDC provider ID you configured in Firebase
const oidcProvider = new OAuthProvider(providerId);
console.log(
  `[firebase.js] OAuthProvider initialized with provider ID: ${providerId}`
);

export { auth, oidcProvider, signInWithRedirect, getRedirectResult };
